'use strict';

var namespace = 'pollingInstance:';

module.exports = {
  POLLING_STATUS_INITIATED:   namespace + 'POLLING_STATUS_INITIATED',
  POLLING_STATUS_UPDATED:     namespace + 'POLLING_STATUS_UPDATED',
  POLLING_STATUS_COMPLETED:   namespace + 'POLLING_STATUS_COMPLETED'
};
